import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigService {

  public isProdDomain: boolean;

  constructor(private Http: HttpClient) {
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadConfig(): Observable<any> {
    return this.Http.get(`assets/confs/${window.location.hostname}.config.json`);
  }
}
